/**
 * Bloco #54: cor da marcação na grade da Agenda pelo status do atendimento.
 *
 * - Compareceu → verde; Não Compareceu → vermelho;
 * - paciente confirmou pelo link do WhatsApp → lilás (identidade Allodos);
 * - reserva do link externo aguardando confirmação → fundo branco;
 * - atendimento criado na agenda interna → cor padrão (verde-escuro);
 * - compromisso e bloqueio mantêm as cores próprias.
 *
 * Mesma regra em todas as visões (mês, semana, dia, lista).
 */
export type ToneInput = {
  type: 'appointment' | 'compromise' | 'block' | string;
  status?: 'Compareceu' | 'Não Compareceu' | string;
  patientResponse?: 'CONFIRMADO' | 'CANCELADO' | string;
  source?: 'agenda' | 'portal' | string;
};

export type EventTone = {
  /** Fundo, texto e borda da marcação. */
  card: string;
  /** Marcador redondo da linha do tempo. */
  dot: string;
  key: 'compareceu' | 'faltou' | 'confirmado' | 'aguardando' | 'atendimento' | 'compromisso' | 'bloqueio';
};

export function eventTone(e: ToneInput): EventTone {
  if (e.status === 'Compareceu') return { key: 'compareceu', card: 'bg-green-600 text-white border-green-700/40', dot: 'bg-green-500' };
  if (e.status === 'Não Compareceu') return { key: 'faltou', card: 'bg-rose-600 text-white border-rose-700/35', dot: 'bg-rose-500' };
  if (e.type === 'appointment' && e.patientResponse === 'CONFIRMADO') {
    return { key: 'confirmado', card: 'bg-violet-500 text-white border-violet-600/40', dot: 'bg-violet-500' };
  }
  if (e.type === 'appointment' && e.source === 'portal') {
    // Fundo branco: os textos internos (escritos em branco para os cartões
    // coloridos) passam a escuro.
    return {
      key: 'aguardando',
      card: 'bg-white text-slate-800 border-slate-300 [&_*]:!text-slate-700',
      dot: 'bg-white ring-2 ring-slate-300',
    };
  }
  if (e.type === 'appointment') return { key: 'atendimento', card: 'bg-emerald-700 text-white border-emerald-800/30', dot: 'bg-emerald-700' };
  if (e.type === 'compromise') return { key: 'compromisso', card: 'bg-amber-700 text-white border-amber-800/30', dot: 'bg-amber-700' };
  return { key: 'bloqueio', card: 'bg-purple-700 text-white border-purple-800/30', dot: 'bg-purple-700' };
}
